import { isNil } from "es-toolkit";
import { Button } from "@/shared/ui/button";
import { usePwaUpdate } from "@/features/pwa-update/pwa-update.hooks";
import { pwaUpdateModel } from "@/features/pwa-update/pwa-update.model";

type Props = Readonly<{
  /** When true, the banner is suppressed (e.g. during an active training session). */
  suppressed?: boolean;
}>;

export const PwaUpdateBanner = ({ suppressed = false }: Props) => {
  const { updater, dismissed: isDismissed } = usePwaUpdate();

  if (isNil(updater) || isDismissed || suppressed) return null;

  return (
    <output
      data-testid="pwa-update"
      className="fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-2 rounded-[var(--r-sm)] border-[1.5px] border-[var(--line)] bg-[var(--panel)] px-3 py-2 font-mono text-[10.5px] uppercase tracking-[0.06em] text-[var(--text)]"
    >
      <span data-testid="pwa-update__message">New version available</span>
      <Button
        type="button"
        size="sm"
        data-testid="pwa-update__reload"
        onClick={() => {
          void updater(true);
        }}
      >
        Reload
      </Button>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        data-testid="pwa-update__dismiss"
        onClick={pwaUpdateModel.dismiss}
      >
        Later
      </Button>
    </output>
  );
};
